import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { DuplicateForecastForm } from '../../components/duplicate-forecast-form';
import { useDuplicateForecastContext } from '../../context/duplicate-forecast-context';

export interface DuplicateForecastFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onDuplicate: () => void;
}

export const DuplicateForecastFormWizardScreen = ({
  error,
  onClose,
  onDuplicate
}: DuplicateForecastFormWizardScreenProps) => {
  const intl = useIntl();
  const { form } = useDuplicateForecastContext();

  const duplicateText = intl.formatMessage({
    id: 'common.duplicate',
    defaultMessage: 'Duplicate'
  });

  return (
    <WizardScreen onCancel={onClose} onCreate={onDuplicate} footerMode={FooterMode.CREATE} createText={duplicateText}>
      <>
        {error && <WizardFormError mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />
        <DuplicateForecastForm
          duration={form.duration}
          errors={form.errors}
          formType={form.formType}
          from={form.from}
          maxDate={form.maxDate}
          minDate={form.minDate}
          name={form.name}
          onChangeDuration={form.onChangeDuration}
          onChangeFrom={form.onChangeFrom}
          onChangeName={form.onChangeName}
          onChangePreviousActuals={form.onChangePreviousActuals}
          previousActuals={form.previousActuals}
          revalidate={form.revalidate}
        />
      </>
    </WizardScreen>
  );
};
